<template>
  <v-sheet class="mx-auto" max-width="2000">
    <v-card class="mx-auto" color="primary" variant="text" elevation="0"
            title="Healthcare resource utilization"
            subtitle=""
            v-if="(healthcareResourceUtilizationInPatientChartData.length !== 0)
                  || (healthcareResourceUtilizationOutPatientChartData.length !== 0)">
      <v-row align="center" no-gutters>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-in-patient-before-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        :data="healthcareResourceUtilizationInPatientBeforeIcdChartData"
                        :options="healthcareResourceUtilizationInPatientBeforeIcdChartOptions"
                        :key="'healthcareResourceUtilizationInPatientBeforeIcdChart' + healthcareResourceUtilizationInPatientBeforeIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationInPatientBeforeIcdChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-in-patient-before-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-in-patient-before-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-in-patient-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        :data="healthcareResourceUtilizationInPatientChartData"
                        :options="healthcareResourceUtilizationInPatientChartOptions"
                        :key="'healthcareResourceUtilizationInPatientChart' + healthcareResourceUtilizationInPatientChartKeyIndex"
                        v-if="healthcareResourceUtilizationInPatientChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-in-patient-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-in-patient-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-out-patient-before-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        :data="healthcareResourceUtilizationOutPatientBeforeIcdChartData"
                        :options="healthcareResourceUtilizationOutPatientBeforeIcdChartOptions"
                        :key="'healthcareResourceUtilizationOutPatientBeforeIcdChart' + healthcareResourceUtilizationOutPatientBeforeIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationOutPatientBeforeIcdChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-out-patient-before-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-out-patient-before-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-out-patient-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        :data="healthcareResourceUtilizationOutPatientChartData"
                        :options="healthcareResourceUtilizationOutPatientChartOptions"
                        :key="'healthcareResourceUtilizationOutPatientChart' + healthcareResourceUtilizationOutPatientChartKeyIndex"
                        v-if="healthcareResourceUtilizationOutPatientChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-out-patient-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-out-patient-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-specialist-care-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        :data="healthcareResourceUtilizationSpecialistCareChartData"
                        :options="healthcareResourceUtilizationSpecialistCareChartOptions"
                        :key="'healthcareResourceUtilizationSpecialistCareChart' + healthcareResourceUtilizationSpecialistCareChartKeyIndex"
                        v-if="healthcareResourceUtilizationSpecialistCareChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-specialist-care-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-specialist-care-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" no-gutters>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-specialist-care-by-icd-before-diagnosis-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        @ready="healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartReady"
                        :data="healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartData"
                        :options="healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartOptions"
                        :key="'healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChart' + healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartKeyIndex"
                        v-if="healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-specialist-care-by-icd-before-diagnosis-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-specialist-care-by-icd-before-diagnosis-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-specialist-care-by-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        @ready="healthcareResourceUtilizationSpecialistCareByIcdChartReady"
                        :data="healthcareResourceUtilizationSpecialistCareByIcdChartData"
                        :options="healthcareResourceUtilizationSpecialistCareByIcdChartOptions"
                        :key="'healthcareResourceUtilizationSpecialistCareByIcdChart' + healthcareResourceUtilizationSpecialistCareByIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationSpecialistCareByIcdChartData.length !== 0"/>
                <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-specialist-care-by-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-specialist-care-by-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';
import {GChart} from 'vue-google-charts'
import axios from "axios";
import { VueToPrint } from "vue-to-print";

export default defineComponent({
  name: 'RareDiseaseTreatmentPatternInterventions',
  props: {
    icd: String,
    visible: Boolean
  },
  components: {
    GChart,
    VueToPrint
  },
  data: () => ({
    healthcareResourceUtilizationInPatientChartKeyIndex: 0,
    healthcareResourceUtilizationInPatientChartData: [],
    healthcareResourceUtilizationInPatientChartOptions: {
      backgroundColor: {
        fill: '#364c5b'
      },
      title: 'In-patient care',
      titlePosition: 'out',
      titleTextStyle: {
        color: '#ffffff',
        bold: false
      },
      height: 800,
      colors: ['#a6cee3', '#fb9a99', '#b2df8a', '#fdbf6f', '#cab2d6', '#ffff99', '#1f78b4', '#33a02c'],
      legend: {
        position: 'top',
        alignment: 'end',
        maxLines: 5,
        textStyle: {
          color: '#c0c0c0',
          fontSize: 12
        },
        scrollArrows: {
          activeColor: '#f0f0f0',
          inactiveColor: 'c0c0c0'
        },
        pagingTextStyle: {
          color: '#f0f0f0'
        }
      },
      series: {
        0: {
          targetAxisIndex: 0
        },
        1: {
          targetAxisIndex: 1,
          type: 'line',
          pointShape: 'diamond',
          pointSize: 10
        }
      },
      hAxis: {
        title: 'Year',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff',
          fontSize: 12
        }
      },
      vAxes: {
        0: {
          title: 'Total number of days',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            count: 0
          },
          minorGridlines: {
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        },
        1: {
          title: 'Median number of days per patient',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            color: '#364c5b',
            count: 0
          },
          minorGridlines: {
            color: '#364c5b',
            count: 0
          },
          ticks: [],
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        }
      },
      tooltip: {
        isHtml: true
      },
      annotations: {
        textStyle: {
          fontSize: 12,
          color: '#808080',
          auraColor: 'none'
        }
      },
      animation: {
        startup: true,
        duration: 500,
        easing: 'out'
      }
    },
    healthcareResourceUtilizationOutPatientChartKeyIndex: 0,
    healthcareResourceUtilizationOutPatientChartData: [],
    healthcareResourceUtilizationOutPatientChartOptions: {
      backgroundColor: {
        fill: '#364c5b'
      },
      title: 'Out-patient care',
      titlePosition: 'out',
      titleTextStyle: {
        color: '#ffffff',
        bold: false
      },
      height: 800,
      colors: ['#a6cee3', '#fb9a99', '#b2df8a', '#fdbf6f', '#cab2d6', '#ffff99', '#1f78b4', '#33a02c'],
      legend: {
        position: 'top',
        alignment: 'end',
        maxLines: 5,
        textStyle: {
          color: '#c0c0c0',
          fontSize: 12
        },
        scrollArrows: {
          activeColor: '#f0f0f0',
          inactiveColor: 'c0c0c0'
        },
        pagingTextStyle: {
          color: '#f0f0f0'
        }
      },
      series: {
        0: {
          targetAxisIndex: 0
        },
        1: {
          targetAxisIndex: 1,
          type: 'line',
          pointShape: 'diamond',
          pointSize: 10
        }
      },
      hAxis: {
        title: 'Year',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff',
          fontSize: 12
        }
      },
      vAxes: {
        0: {
          title: 'Total number of visits',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            count: 0
          },
          minorGridlines: {
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        },
        1: {
          title: 'Median number of visits per patient',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            color: '#364c5b',
            count: 0
          },
          minorGridlines: {
            color: '#364c5b',
            count: 0
          },
          ticks: [],
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        }
      },
      tooltip: {
        isHtml: true
      },
      annotations: {
        textStyle: {
          fontSize: 12,
          color: '#808080',
          auraColor: 'none'
        }
      },
      animation: {
        startup: true,
        duration: 500,
        easing: 'out'
      }
    },
    healthcareResourceUtilizationSpecialistCareChartKeyIndex: 0,
    healthcareResourceUtilizationSpecialistCareChartData: [],
    healthcareResourceUtilizationSpecialistCareChartOptions: {
      backgroundColor: {
        fill: '#364c5b'
      },
      title: 'All specialist care',
      titlePosition: 'out',
      titleTextStyle: {
        color: '#ffffff',
        bold: false
      },
      height: 800,
      colors: ['#a6cee3', '#fb9a99', '#b2df8a', '#fdbf6f', '#cab2d6', '#ffff99', '#1f78b4', '#33a02c'],
      legend: {
        position: 'top',
        alignment: 'end',
        maxLines: 5,
        textStyle: {
          color: '#c0c0c0',
          fontSize: 12
        },
        scrollArrows: {
          activeColor: '#f0f0f0',
          inactiveColor: 'c0c0c0'
        },
        pagingTextStyle: {
          color: '#f0f0f0'
        }
      },
      series: {
        0: {
          targetAxisIndex: 0
        },
        1: {
          targetAxisIndex: 1,
          type: 'line',
          pointShape: 'diamond',
          pointSize: 10
        }
      },
      hAxis: {
        title: 'Year',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff',
          fontSize: 12
        }
      },
      vAxes: {
        0: {
          title: 'Total number of visits',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            count: 0
          },
          minorGridlines: {
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        },
        1: {
          title: 'Patients at risk (N)',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            color: '#364c5b',
            count: 0
          },
          minorGridlines: {
            color: '#364c5b',
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        }
      },
      tooltip: {
        isHtml: true
      },
      annotations: {
        textStyle: {
          fontSize: 12,
          color: '#808080',
          auraColor: 'none'
        }
      },
      animation: {
        startup: true,
        duration: 500,
        easing: 'out'
      }
    },
    healthcareResourceUtilizationSpecialistCareByIcdChartKeyIndex: 0,
    healthcareResourceUtilizationSpecialistCareByIcdChartSelectedSeries: undefined,
    healthcareResourceUtilizationSpecialistCareByIcdChartData: [],
    healthcareResourceUtilizationSpecialistCareByIcdChartOptions: {
      backgroundColor: {
        fill: '#364c5b'
      },
      title: 'Specialist care by disease classification',
      titlePosition: 'out',
      titleTextStyle: {
        color: '#ffffff',
        bold: false
      },
      height: 800,
      colors: ['#fb9a99', '#a6cee3', '#b2df8a', '#fdbf6f', '#cab2d6', '#ffff99', '#1f78b4', '#33a02c', '#bdbdc7'],
      legend: {
        position: 'top',
        alignment: 'end',
        maxLines: 5,
        textStyle: {
          color: '#c0c0c0',
          fontSize: 12
        },
        scrollArrows: {
          activeColor: '#f0f0f0',
          inactiveColor: 'c0c0c0'
        },
        pagingTextStyle: {
          color: '#f0f0f0'
        }
      },
      isStacked: true,
      series: {
        0: {
          targetAxisIndex: 1,
          type: 'line',
          pointShape: 'diamond',
          pointSize: 10
        },
        1: {
          targetAxisIndex: 0
        }
      },
      hAxis: {
        title: 'Year',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff',
          fontSize: 12
        }
      },
      vAxes: {
        0: {
          title: 'Total number of visits',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            count: 0
          },
          minorGridlines: {
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        },
        1: {
          title: 'Patients at risk (N)',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            color: '#364c5b',
            count: 0
          },
          minorGridlines: {
            color: '#364c5b',
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        }
      },
      intervals: {
        'style': 'boxes',
        'boxWidth': 1,
        'lineWidth': 0,
        'fillOpacity': 0.2
      },
      tooltip: {
        isHtml: true
      },
      annotations: {
        textStyle: {
          fontSize: 12,
          color: '#808080',
          auraColor: 'none'
        }
      },
      animation: {
        startup: true,
        duration: 500,
        easing: 'out'
      }
    },
    healthcareResourceUtilizationInPatientBeforeIcdChartKeyIndex: 0,
    healthcareResourceUtilizationInPatientBeforeIcdChartData: [],
    healthcareResourceUtilizationInPatientBeforeIcdChartOptions: {
      backgroundColor: {
        fill: '#364c5b'
      },
      title: 'In-patient care before diagnosis',
      titlePosition: 'out',
      titleTextStyle: {
        color: '#ffffff',
        bold: false
      },
      height: 800,
      colors: ['#a6cee3', '#fb9a99', '#b2df8a', '#fdbf6f', '#cab2d6', '#ffff99', '#1f78b4', '#33a02c'],
      legend: {
        position: 'top',
        alignment: 'end',
        maxLines: 5,
        textStyle: {
          color: '#c0c0c0',
          fontSize: 12
        },
        scrollArrows: {
          activeColor: '#f0f0f0',
          inactiveColor: 'c0c0c0'
        },
        pagingTextStyle: {
          color: '#f0f0f0'
        }
      },
      series: {
        0: {
          targetAxisIndex: 0
        },
        1: {
          targetAxisIndex: 1,
          type: 'line',
          pointShape: 'diamond',
          pointSize: 10
        }
      },
      hAxis: {
        title: 'Year',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff',
          fontSize: 12
        }
      },
      vAxes: {
        0: {
        title: 'Total number of days',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff',
          fontSize: 12
        }
        },
        1: {
          title: 'Patients at risk (N)',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            color: '#364c5b',
            count: 0
          },
          minorGridlines: {
            color: '#364c5b',
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        }
      },
      tooltip: {
        isHtml: true
      },
      annotations: {
        textStyle: {
          fontSize: 12,
          color: '#808080',
          auraColor: 'none'
        }
      },
      animation: {
        startup: true,
        duration: 500,
        easing: 'out'
      }
    },
    healthcareResourceUtilizationOutPatientBeforeIcdChartKeyIndex: 0,
    healthcareResourceUtilizationOutPatientBeforeIcdChartData: [],
    healthcareResourceUtilizationOutPatientBeforeIcdChartOptions: {
      backgroundColor: {
        fill: '#364c5b'
      },
      title: 'Out-patient care before diagnosis',
      titlePosition: 'out',
      titleTextStyle: {
        color: '#ffffff',
        bold: false
      },
      height: 800,
      colors: ['#a6cee3', '#fb9a99', '#b2df8a', '#fdbf6f', '#cab2d6', '#ffff99', '#1f78b4', '#33a02c'],
      legend: {
        position: 'top',
        alignment: 'end',
        maxLines: 5,
        textStyle: {
          color: '#c0c0c0',
          fontSize: 12
        },
        scrollArrows: {
          activeColor: '#f0f0f0',
          inactiveColor: 'c0c0c0'
        },
        pagingTextStyle: {
          color: '#f0f0f0'
        }
      },
      series: {
        0: {
          targetAxisIndex: 0
        },
        1: {
          targetAxisIndex: 1,
          type: 'line',
          pointShape: 'diamond',
          pointSize: 10
        }
      },
      hAxis: {
        title: 'Year',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff',
          fontSize: 12
        }
      },
      vAxes: {
        0: {
        title: 'Total number of days',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff',
          fontSize: 12
        }
        },
        1: {
          title: 'Patients at risk (N)',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            color: '#364c5b',
            count: 0
          },
          minorGridlines: {
            color: '#364c5b',
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        }
      },
      tooltip: {
        isHtml: true
      },
      annotations: {
        textStyle: {
          fontSize: 12,
          color: '#808080',
          auraColor: 'none'
        }
      },
      animation: {
        startup: true,
        duration: 500,
        easing: 'out'
      }
    },
    healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartKeyIndex: 0,
    healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartSelectedSeries: undefined,
    healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartData: [],
    healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartOptions: {
      backgroundColor: {
        fill: '#364c5b'
      },
      title: 'Specialist care by disease classification, before diagnosis',
      titlePosition: 'out',
      titleTextStyle: {
        color: '#ffffff',
        bold: false
      },
      height: 800,
      colors: ['#fb9a99', '#a6cee3', '#b2df8a', '#fdbf6f', '#cab2d6', '#ffff99', '#1f78b4', '#33a02c', '#bdbdc7'],
      legend: {
        position: 'top',
        alignment: 'end',
        maxLines: 5,
        textStyle: {
          color: '#c0c0c0',
          fontSize: 12
        },
        scrollArrows: {
          activeColor: '#f0f0f0',
          inactiveColor: 'c0c0c0'
        },
        pagingTextStyle: {
          color: '#f0f0f0'
        }
      },
      isStacked: true,
      series: {
        0: {
          targetAxisIndex: 1,
          type: 'line',
          pointShape: 'diamond',
          pointSize: 10
        },
        1: {
          targetAxisIndex: 0
        }
      },
      hAxis: {
        title: 'Year',
        titleTextStyle: {
          color: '#f0f0f0',
          italic: false
        },
        gridlines: {
          count: 0
        },
        minorGridlines: {
          count: 0
        },
        textStyle: {
          color: '#ffffff',
          fontSize: 12
        }
      },
      vAxes: {
        0: {
          title: 'Total number of visits',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            count: 0
          },
          minorGridlines: {
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        },
        1: {
          title: 'Patients at risk (N)',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            count: 0,
            color: '#364c5b',
          },
          minorGridlines: {
            count: 0,
            color: '#364c5b',
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          }
        }
      },
      intervals: {
        'style': 'boxes',
        'boxWidth': 1,
        'lineWidth': 0,
        'fillOpacity': 0.2
      },
      tooltip: {
        isHtml: true
      },
      annotations: {
        textStyle: {
          fontSize: 12,
          color: '#808080',
          auraColor: 'none'
        }
      },
      animation: {
        startup: true,
        duration: 500,
        easing: 'out'
      }
    }
  }),
  watch: {
    healthcareResourceUtilizationSpecialistCareByIcdChartSelectedSeries() {
      this.loadHealthcareResourceUtilizationSpecialistCareByIcdData(
          this.healthcareResourceUtilizationSpecialistCareByIcdChartSelectedSeries).then((response) => {
        this.healthcareResourceUtilizationSpecialistCareByIcdChartData = response.data.data
        this.healthcareResourceUtilizationSpecialistCareByIcdChartOptions.title = response.data.comment
      })
    },
    healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartSelectedSeries() {
      this.loadHealthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisData(
          this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartSelectedSeries).then((response) => {
        this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartData = response.data.data
        this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartOptions.title = response.data.comment
      })
    }
  },
  methods: {
    forceRerender() {
      this.healthcareResourceUtilizationInPatientChartKeyIndex += 1;
      this.healthcareResourceUtilizationOutPatientChartKeyIndex += 1;
      this.healthcareResourceUtilizationSpecialistCareChartKeyIndex += 1;
      this.healthcareResourceUtilizationSpecialistCareByIcdChartKeyIndex += 1;
      this.healthcareResourceUtilizationInPatientBeforeIcdChartKeyIndex += 1;
      this.healthcareResourceUtilizationOutPatientBeforeIcdChartKeyIndex += 1;
      this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartKeyIndex += 1;
    },
    async loadHealthcareResourceUtilizationInPatientData() {
      return axios.get('rare-disease/healthcare-in-patient-resource-utilization',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              icd: this.icd
            }
          });
    },
    async loadHealthcareResourceUtilizationOutPatientData() {
      return axios.get('rare-disease/healthcare-out-patient-resource-utilization',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              icd: this.icd
            }
          });
    },
    async loadHealthcareResourceUtilizationSpecialistCareData() {
      return axios.get('rare-disease/healthcare-specialist-care-resource-utilization',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              icd: this.icd
            }
          });
    },
    async loadHealthcareResourceUtilizationInPatientBeforeIcdData() {
      return axios.get('rare-disease/healthcare-in-patient-before-icd-resource-utilization',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              icd: this.icd
            }
          });
    },
    async loadHealthcareResourceUtilizationOutPatientBeforeIcdData() {
      return axios.get('rare-disease/healthcare-out-patient-before-icd-resource-utilization',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              icd: this.icd
            }
          });
    },
    async loadHealthcareResourceUtilizationSpecialistCareByIcdData(diagnosisGroup) {
      return axios.get('rare-disease/healthcare-specialist-care-by-icd-resource-utilization',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              icd: this.icd,
              diagnosis_group: diagnosisGroup
            }
          });
    },
    async loadHealthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisData(diagnosisGroup) {
      return axios.get('rare-disease/healthcare-specialist-care-by-icd-before-diagnosis-resource-utilization',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              icd: this.icd,
              diagnosis_group: diagnosisGroup
            }
          });
    },
    async healthcareResourceUtilizationSpecialistCareByIcdChartReady(chart, google) {
      const setSeriesChartSelection = (selectedColumn) => {
        let selectedSeries = this.healthcareResourceUtilizationSpecialistCareByIcdChartData[0][selectedColumn]
        if (this.healthcareResourceUtilizationSpecialistCareByIcdChartSelectedSeries === selectedSeries) {
          this.healthcareResourceUtilizationSpecialistCareByIcdChartSelectedSeries = undefined
        } else {
          this.healthcareResourceUtilizationSpecialistCareByIcdChartSelectedSeries = selectedSeries
        }
      }

      const resetSeriesChartSelection = () => {
        this.healthcareResourceUtilizationSpecialistCareByIcdChartSelectedSeries = undefined
      }

      const seriesSelectHandler = function () {
        const selection = chart.getSelection()
        if (selection.length === 0) {
          resetSeriesChartSelection()
          return
        }
        const selectedItem = selection[0];
        setSeriesChartSelection(selectedItem.column)
      }

      google.visualization.events.addListener(chart, 'select', seriesSelectHandler);
    },
    async healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartReady(chart, google) {
      const setSeriesChartSelection = (selectedColumn) => {
        let selectedSeries = this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartData[0][selectedColumn]
        if (this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartSelectedSeries === selectedSeries) {
          this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartSelectedSeries = undefined
        } else {
          this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartSelectedSeries = selectedSeries
        }
      }

      const resetSeriesChartSelection = () => {
        this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartSelectedSeries = undefined
      }

      const seriesSelectHandler = function () {
        const selection = chart.getSelection()
        if (selection.length === 0) {
          resetSeriesChartSelection()
          return
        }
        const selectedItem = selection[0];
        setSeriesChartSelection(selectedItem.column)
      }

      google.visualization.events.addListener(chart, 'select', seriesSelectHandler);
    },
  },
  async mounted() {
    await Promise.all([
      this.loadHealthcareResourceUtilizationInPatientData(),
      this.loadHealthcareResourceUtilizationOutPatientData(),
      this.loadHealthcareResourceUtilizationSpecialistCareData(),
      this.loadHealthcareResourceUtilizationInPatientBeforeIcdData(),
      this.loadHealthcareResourceUtilizationOutPatientBeforeIcdData(),
      this.loadHealthcareResourceUtilizationSpecialistCareByIcdData(),
      this.loadHealthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisData()
    ]).then(responses => {
      this.healthcareResourceUtilizationInPatientChartData = responses[0].data.data
      this.healthcareResourceUtilizationInPatientChartOptions.title = responses[0].data.comment
      this.healthcareResourceUtilizationInPatientChartOptions.vAxes["1"]["ticks"] = responses[0].data.series1Ticks
      this.healthcareResourceUtilizationOutPatientChartData = responses[1].data.data
      this.healthcareResourceUtilizationOutPatientChartOptions.title = responses[1].data.comment
      this.healthcareResourceUtilizationOutPatientChartOptions.vAxes["1"]["ticks"] = responses[1].data.series1Ticks
      this.healthcareResourceUtilizationSpecialistCareChartData = responses[2].data.data
      this.healthcareResourceUtilizationSpecialistCareChartOptions.title = responses[2].data.comment
      this.healthcareResourceUtilizationInPatientBeforeIcdChartData = responses[3].data.data
      this.healthcareResourceUtilizationInPatientBeforeIcdChartOptions.title = responses[3].data.comment
      this.healthcareResourceUtilizationOutPatientBeforeIcdChartData = responses[4].data.data
      this.healthcareResourceUtilizationOutPatientBeforeIcdChartOptions.title = responses[4].data.comment
      this.healthcareResourceUtilizationSpecialistCareByIcdChartData = responses[5].data.data
      this.healthcareResourceUtilizationSpecialistCareByIcdChartOptions.title = responses[5].data.comment
      this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartData = responses[6].data.data
      this.healthcareResourceUtilizationSpecialistCareByIcdBeforeDiagnosisChartOptions.title = responses[6].data.comment
    })
  },
  updated() {
    if (this.visible) {
      this.forceRerender()
    }
  }
});
</script>

<style scoped>
@media print {
  .mx-auto {
    zoom: 50%;
  }
}
</style>
